/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Botica API
 * API for the Botica professional network for Venezuelan pharmacists
 * OpenAPI spec version: v1
 */
export type VerificationStatus = typeof VerificationStatus[keyof typeof VerificationStatus];


export const VerificationStatus = {
  PendingDocuments: 'PendingDocuments',
  PendingReview: 'PendingReview',
  Verified: 'Verified',
  Rejected: 'Rejected',
} as const;

export interface CredentialReviewerDto {
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  email?: string | null;
}

export interface AdminCredentialDto {
  id?: string;
  /** @nullable */
  mppsNumber?: string | null;
  /** @nullable */
  colfarNumber?: string | null;
  /** @nullable */
  imprefarNumber?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  university?: string | null;
  graduationYear?: number;
  /** @nullable */
  credentialDocumentUrl?: string | null;
  verificationStatus?: VerificationStatus;
  /** @nullable */
  rejectionReason?: string | null;
  /** @nullable */
  submittedAt?: string | null;
  /** @nullable */
  reviewedAt?: string | null;
  reviewedBy?: CredentialReviewerDto;
  userId?: string;
  /** @nullable */
  userDisplayName?: string | null;
  /** @nullable */
  userEmail?: string | null;
  /** @nullable */
  userState?: string | null;
}

export interface UserDto {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  isVerified?: boolean;
  emailConfirmed?: boolean;
  /** @nullable */
  verificationStatus?: string | null;
  canPost?: boolean;
}

export interface AuthResponse {
  /** @nullable */
  accessToken?: string | null;
  /** @nullable */
  refreshToken?: string | null;
  expiresAt?: string;
  user?: UserDto;
}

/**
 * @nullable
 */
export type AdminTokenLoginResponseKind = typeof AdminTokenLoginResponseKind[keyof typeof AdminTokenLoginResponseKind] | null;


export const AdminTokenLoginResponseKind = {
  token: 'token',
} as const;

export interface AdminTokenLoginResponse {
  tokens?: AuthResponse;
  /** @nullable */
  readonly kind: AdminTokenLoginResponseKind;
}

/**
 * @nullable
 */
export type AdminMfaRequiredResponseKind = typeof AdminMfaRequiredResponseKind[keyof typeof AdminMfaRequiredResponseKind] | null;


export const AdminMfaRequiredResponseKind = {
  mfa_required: 'mfa_required',
} as const;

export interface AdminMfaRequiredResponse {
  /** @nullable */
  challengeToken?: string | null;
  /** @nullable */
  readonly kind: AdminMfaRequiredResponseKind;
}

/**
 * @nullable
 */
export type AdminMfaEnrollmentRequiredResponseKind = typeof AdminMfaEnrollmentRequiredResponseKind[keyof typeof AdminMfaEnrollmentRequiredResponseKind] | null;


export const AdminMfaEnrollmentRequiredResponseKind = {
  mfa_enrollment_required: 'mfa_enrollment_required',
} as const;

export interface AdminMfaEnrollmentRequiredResponse {
  /** @nullable */
  challengeToken?: string | null;
  /** @nullable */
  qrCodeUri?: string | null;
  /** @nullable */
  manualEntryKey?: string | null;
  /** @nullable */
  readonly kind: AdminMfaEnrollmentRequiredResponseKind;
}

export type AdminLoginResponse = AdminTokenLoginResponse | AdminMfaRequiredResponse | AdminMfaEnrollmentRequiredResponse;

export type ReportTargetType = typeof ReportTargetType[keyof typeof ReportTargetType];


export const ReportTargetType = {
  Post: 'Post',
  Comment: 'Comment',
  Message: 'Message',
  User: 'User',
  AvailabilityRequest: 'AvailabilityRequest',
} as const;

export type ReportReason = typeof ReportReason[keyof typeof ReportReason];


export const ReportReason = {
  Spam: 'Spam',
  Harassment: 'Harassment',
  Misinformation: 'Misinformation',
  Impersonation: 'Impersonation',
  Other: 'Other',
} as const;

export type ReportStatus = typeof ReportStatus[keyof typeof ReportStatus];


export const ReportStatus = {
  Pending: 'Pending',
  Actioned: 'Actioned',
  Dismissed: 'Dismissed',
} as const;

export interface ReportedContentDto {
  /** @nullable */
  authorUserId?: string | null;
  /** @nullable */
  authorFullName?: string | null;
  /** @nullable */
  body?: string | null;
  /** @nullable */
  createdAt?: string | null;
  isDeleted?: boolean;
  isPurged?: boolean;
}

export interface AdminReportDto {
  id?: string;
  reporterUserId?: string;
  /** @nullable */
  reporterFullName?: string | null;
  targetType?: ReportTargetType;
  targetId?: string;
  reason?: ReportReason;
  /** @nullable */
  details?: string | null;
  status?: ReportStatus;
  createdAt?: string;
  lastReportedAt?: string;
  /** @nullable */
  reviewedAt?: string | null;
  /** @nullable */
  reviewedByUserId?: string | null;
  /** @nullable */
  reviewedByFullName?: string | null;
  /** @nullable */
  resolutionNote?: string | null;
  totalReportsForTarget?: number;
  content?: ReportedContentDto;
}

export interface ReportCountsDto {
  pending?: number;
  actioned?: number;
  dismissed?: number;
  total?: number;
}

export interface AdminReportListResponse {
  /** @nullable */
  reports?: AdminReportDto[] | null;
  counts?: ReportCountsDto;
}

export interface AdminResetPasswordResponse {
  /** @nullable */
  temporaryPassword?: string | null;
}

export interface AdminUserDto {
  id?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  emailConfirmed?: boolean;
  phoneNumberConfirmed?: boolean;
  createdAt?: string;
  /** @nullable */
  lastLoginAt?: string | null;
  isAdmin?: boolean;
  /** @nullable */
  roles?: string[] | null;
  credentialStatus?: VerificationStatus;
  /** @nullable */
  credentialSubmittedAt?: string | null;
  /** @nullable */
  credentialReviewedAt?: string | null;
  postCount?: number;
  commentCount?: number;
}

export interface AdminUserListResponse {
  /** @nullable */
  users?: AdminUserDto[] | null;
  totalCount?: number;
  page?: number;
  pageSize?: number;
  totalPages?: number;
}

export interface AuthorSummary {
  id?: string;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  verificationStatus?: string | null;
  /** @nullable */
  university?: string | null;
  /** @nullable */
  badge?: string | null;
}

export interface AvailabilityReportDto {
  id?: string;
  /** @nullable */
  drugConceptId?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  registrationProductName?: string | null;
  /** @nullable */
  reporterName?: string | null;
  /** @nullable */
  pharmacyPlaceId?: string | null;
  /** @nullable */
  pharmacyName?: string | null;
  /** @nullable */
  pharmacyAddress?: string | null;
  /** @nullable */
  pharmacyPhone?: string | null;
  /** @nullable */
  pharmacySource?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  strength?: string | null;
  /** @nullable */
  strengthNormalized?: string | null;
  /** @nullable */
  priceBolivares?: number | null;
  /** @nullable */
  priceUsd?: number | null;
  reportedAt?: string;
  verifiedCount?: number;
  wasSolicited?: boolean;
  /** @nullable */
  requestId?: string | null;
}

export interface AvailabilityRequestDto {
  id?: string;
  drugConceptId?: string;
  /** @nullable */
  drugName?: string | null;
  requesterUserId?: string;
  /** @nullable */
  requesterName?: string | null;
  /** @nullable */
  stateCode?: string | null;
  /** @nullable */
  stateName?: string | null;
  /** @nullable */
  strength?: string | null;
  /** @nullable */
  strengthNormalized?: string | null;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  status?: string | null;
  isOpen?: boolean;
  createdAt?: string;
  expiresAt?: string;
  /** @nullable */
  resolvedAt?: string | null;
  responseCount?: number;
}

export interface AvailabilityRequestListResponse {
  /** @nullable */
  requests?: AvailabilityRequestDto[] | null;
  /** @nullable */
  nextCursor?: string | null;
  hasMore?: boolean;
}

export type AvailabilityStatus = typeof AvailabilityStatus[keyof typeof AvailabilityStatus];


export const AvailabilityStatus = {
  InStock: 'InStock',
  OutOfStock: 'OutOfStock',
  Limited: 'Limited',
} as const;

export type BlockReason = typeof BlockReason[keyof typeof BlockReason];


export const BlockReason = {
  Spam: 'Spam',
  Harassment: 'Harassment',
  InappropriateContent: 'InappropriateContent',
  Other: 'Other',
} as const;

export interface BlockUserRequest {
  blockedUserId?: string;
  reason?: BlockReason;
}

export interface ChangePasswordRequest {
  /** @nullable */
  currentPassword?: string | null;
  /** @nullable */
  newPassword?: string | null;
}

export interface ChangePasswordResponse {
  /** @nullable */
  message?: string | null;
}

export interface ClinicalSectionDto {
  /** @nullable */
  sectionNumber?: string | null;
  /** @nullable */
  parentSection?: string | null;
  /** @nullable */
  sectionTitle?: string | null;
  /** @nullable */
  textContent?: string | null;
  textLength?: number;
  /** @nullable */
  sourceMedicineNregistro?: string | null;
  /** @nullable */
  sourceMedicineName?: string | null;
  /** @nullable */
  sourceDocumentUrl?: string | null;
  /** @nullable */
  sourceDocumentModifiedAt?: string | null;
  sourceDocumentDateAvailable?: boolean;
  retrievedAt?: string;
  /** @nullable */
  rawContentHash?: string | null;
}

export interface ClinicalAvailabilityDto {
  available?: boolean;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  reasonDetail?: string | null;
  /** @nullable */
  sourceMedicineNregistro?: string | null;
  /** @nullable */
  sourceMedicineName?: string | null;
  /** @nullable */
  sections?: ClinicalSectionDto[] | null;
}

export interface CommentResponse {
  id?: string;
  postId?: string;
  author?: AuthorSummary;
  /** @nullable */
  parentCommentId?: string | null;
  /** @nullable */
  content?: string | null;
  reactionCount?: number;
  hasReacted?: boolean;
  /** @nullable */
  userReactionType?: string | null;
  isEdited?: boolean;
  isDeleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
  /** @nullable */
  replies?: CommentResponse[] | null;
}

export interface ParticipantSummary {
  id?: string;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  badge?: string | null;
}

export interface ConversationDto {
  id?: string;
  otherParticipant?: ParticipantSummary;
  /** @nullable */
  lastMessagePreview?: string | null;
  unreadCount?: number;
  lastMessageAt?: string;
  createdAt?: string;
}

export interface ConversationListResponse {
  /** @nullable */
  conversations?: ConversationDto[] | null;
  /** @nullable */
  nextCursor?: string | null;
  hasMore?: boolean;
}

export interface ConversationUnreadCountResponse {
  count?: number;
}

export interface CreateAvailabilityReportRequest {
  status?: AvailabilityStatus;
  /** @nullable */
  pharmacyPlaceId?: string | null;
  /** @nullable */
  pharmacyName?: string | null;
  /** @nullable */
  pharmacyAddress?: string | null;
  /** @nullable */
  pharmacyPhone?: string | null;
  /** @nullable */
  pharmacySource?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  strength?: string | null;
  /** @nullable */
  priceBolivares?: number | null;
  /** @nullable */
  priceUsd?: number | null;
  /** @nullable */
  requestId?: string | null;
}

export interface CreateAvailabilityRequestRequest {
  drugConceptId?: string;
  /** @nullable */
  stateCode?: string | null;
  /** @nullable */
  strength?: string | null;
  /** @nullable */
  note?: string | null;
}

export interface CreateCommentRequest {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  parentCommentId?: string | null;
}

export interface CreateConversationRequest {
  recipientUserId?: string;
}

export type PostType = typeof PostType[keyof typeof PostType];


export const PostType = {
  Discussion: 'Discussion',
  Availability: 'Availability',
  Announcement: 'Announcement',
} as const;

export interface CreatePostRequest {
  postType?: PostType;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  stateCode?: string | null;
}

export interface CreateReportRequest {
  targetType?: ReportTargetType;
  targetId?: string;
  reason?: ReportReason;
  /** @nullable */
  details?: string | null;
}

export type WorkplaceType = typeof WorkplaceType[keyof typeof WorkplaceType];


export const WorkplaceType = {
  CommunityPharmacy: 'CommunityPharmacy',
  PharmacyChain: 'PharmacyChain',
  HospitalPharmacy: 'HospitalPharmacy',
  Wholesale: 'Wholesale',
  Industry: 'Industry',
  Academia: 'Academia',
  Regulatory: 'Regulatory',
  Other: 'Other',
} as const;

export interface CreateWorkplaceRequest {
  /** @nullable */
  placeId?: string | null;
  /** @nullable */
  name?: string | null;
  type?: WorkplaceType;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  address?: string | null;
  /** @nullable */
  source?: string | null;
}

export interface CredentialCountsDto {
  total?: number;
  pendingReview?: number;
  verified?: number;
  rejected?: number;
  pendingDocuments?: number;
}

export interface CredentialListResponse {
  /** @nullable */
  credentials?: AdminCredentialDto[] | null;
  counts?: CredentialCountsDto;
}

export interface CredentialResponse {
  id?: string;
  /** @nullable */
  mppsNumber?: string | null;
  /** @nullable */
  colfarNumber?: string | null;
  /** @nullable */
  imprefarNumber?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  universityId?: string | null;
  /** @nullable */
  universityOther?: string | null;
  /** @nullable */
  university?: string | null;
  graduationYear?: number;
  /** @nullable */
  credentialDocumentUrl?: string | null;
  /** @nullable */
  verificationStatus?: string | null;
  /** @nullable */
  rejectionReason?: string | null;
  /** @nullable */
  submittedAt?: string | null;
  createdAt?: string;
}

export interface DrugDetailDto {
  id?: string;
  /** @nullable */
  conceptKey?: string | null;
  /** @nullable */
  preferredDisplayNameEs?: string | null;
  ingredientCount?: number;
  /** @nullable */
  ingredients?: string[] | null;
  /** @nullable */
  aliases?: string[] | null;
  hasClinicalText?: boolean;
  vigenteRegistrationCount?: number;
  publishingRegistrationCount?: number;
}

export interface DrugSearchResultDto {
  id?: string;
  /** @nullable */
  preferredDisplayNameEs?: string | null;
  /** @nullable */
  dci?: string[] | null;
  /** @nullable */
  veBrandNames?: string[] | null;
  vigenteCount?: number;
  hasVigenteProducts?: boolean;
  publishingCount?: number;
}

export interface DrugSearchResponse {
  /** @nullable */
  results?: DrugSearchResultDto[] | null;
  totalHits?: number;
  processingTimeMs?: number;
  /** @nullable */
  query?: string | null;
}

export interface LoginRequest {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  password?: string | null;
}

export interface MarkAllReadResponse {
  updatedCount?: number;
}

export interface MessageAttachmentDto {
  id?: string;
  /** @nullable */
  contentType?: string | null;
  byteSize?: number;
  width?: number;
  height?: number;
}

export interface MessageDto {
  id?: string;
  conversationId?: string;
  senderUserId?: string;
  /** @nullable */
  senderFullName?: string | null;
  /** @nullable */
  senderAvatarUrl?: string | null;
  /** @nullable */
  senderBadge?: string | null;
  /** @nullable */
  body?: string | null;
  isDeleted?: boolean;
  createdAt?: string;
  /** @nullable */
  attachments?: MessageAttachmentDto[] | null;
}

export interface MessageListResponse {
  /** @nullable */
  messages?: MessageDto[] | null;
  /** @nullable */
  nextCursor?: string | null;
  hasMore?: boolean;
}

export interface MfaEnrollRequest {
  /** @nullable */
  challengeToken?: string | null;
  /** @nullable */
  totpCode?: string | null;
}

export interface MfaEnrollResponse {
  /** @nullable */
  accessToken?: string | null;
  /** @nullable */
  refreshToken?: string | null;
  expiresAt?: string;
  user?: UserDto;
  /** @nullable */
  recoveryCodes?: string[] | null;
}

export interface MfaLoginRequest {
  /** @nullable */
  challengeToken?: string | null;
  /** @nullable */
  totpCode?: string | null;
  isRecoveryCode?: boolean;
}

/**
 * @nullable
 */
export type NotificationDtoData = {[key: string]: unknown} | null;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export const NotificationType = {
  CredentialApproved: 'CredentialApproved',
  CredentialRejected: 'CredentialRejected',
  CredentialPendingReview: 'CredentialPendingReview',
  PostComment: 'PostComment',
  CommentReply: 'CommentReply',
  PostReaction: 'PostReaction',
  CommentReaction: 'CommentReaction',
  DirectMessage: 'DirectMessage',
  AvailabilityRequestAnswered: 'AvailabilityRequestAnswered',
  AvailabilityRequestCreated: 'AvailabilityRequestCreated',
} as const;

export interface NotificationDto {
  id?: string;
  type?: NotificationType;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  body?: string | null;
  /** @nullable */
  data?: NotificationDtoData;
  isRead?: boolean;
  /** @nullable */
  readAt?: string | null;
  /** @nullable */
  clickedAt?: string | null;
  createdAt?: string;
}

export interface PaginationInfo {
  currentPage?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
}

export interface NotificationListResponse {
  /** @nullable */
  notifications?: NotificationDto[] | null;
  pagination?: PaginationInfo;
}

export interface NotificationPreferencesDto {
  credentialNotifications?: boolean;
  communityNotifications?: boolean;
  /** @nullable */
  quietHoursStart?: string | null;
  /** @nullable */
  quietHoursEnd?: string | null;
}

export interface PharmacyDetailsDto {
  /** @nullable */
  placeId?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  formattedAddress?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
  /** @nullable */
  stateCode?: string | null;
}

export interface PharmacySearchResultDto {
  /** @nullable */
  placeId?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  locality?: string | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
}

export interface PharmacySearchResponse {
  /** @nullable */
  results?: PharmacySearchResultDto[] | null;
}

export interface PostResponse {
  id?: string;
  author?: AuthorSummary;
  /** @nullable */
  postType?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  stateCode?: string | null;
  /** @nullable */
  stateName?: string | null;
  isLocked?: boolean;
  viewCount?: number;
  commentCount?: number;
  reactionCount?: number;
  hasReacted?: boolean;
  /** @nullable */
  userReactionType?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface PostListResponse {
  /** @nullable */
  posts?: PostResponse[] | null;
  /** @nullable */
  nextCursor?: string | null;
  hasMore?: boolean;
}

export interface ProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  [key: string]: unknown;
}

export interface ProfileResponse {
  id?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  bio?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  hasCredential?: boolean;
  /** @nullable */
  effectiveCredentialStatus?: string | null;
  canPost?: boolean;
  /** @nullable */
  badge?: string | null;
  /** @nullable */
  university?: string | null;
  /** @nullable */
  stateCode?: string | null;
  /** @nullable */
  stateName?: string | null;
  joinDate?: string;
}

export interface PublicProfileDto {
  id?: string;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  effectiveCredentialStatus?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  stateName?: string | null;
  joinDate?: string;
  canMessage?: boolean;
  /** @nullable */
  badge?: string | null;
  /** @nullable */
  university?: string | null;
}

export interface ReactionResponse {
  hasReacted?: boolean;
  /** @nullable */
  reactionType?: string | null;
  totalReactions?: number;
}

export type ReactionType = typeof ReactionType[keyof typeof ReactionType];


export const ReactionType = {
  Like: 'Like',
} as const;

export interface RefreshTokenRequest {
  /** @nullable */
  refreshToken?: string | null;
}

export interface RegisterRequest {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  password?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  mppsNumber?: string | null;
  /** @nullable */
  colfarNumber?: string | null;
  /** @nullable */
  imprefarNumber?: string | null;
  /** @nullable */
  universityId?: string | null;
  /** @nullable */
  universityOther?: string | null;
  graduationYear?: number;
  /** @nullable */
  state?: string | null;
}

export interface RegisterTokenRequest {
  /** @minLength 1 */
  token: string;
  /** @minLength 1 */
  platform: string;
}

export interface RegistrationDto {
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  productName?: string | null;
  /** @nullable */
  dci?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  concentration?: string | null;
  /** @nullable */
  pharmaceuticalForm?: string | null;
  /** @nullable */
  administrationRoute?: string | null;
  /** @nullable */
  salesRegime?: string | null;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  countryOfOrigin?: string | null;
  /** @nullable */
  approvalDate?: string | null;
  /** @nullable */
  renewalDate?: string | null;
  clinical?: ClinicalAvailabilityDto;
}

export interface ReportDto {
  id?: string;
  targetType?: ReportTargetType;
  targetId?: string;
  reason?: ReportReason;
  createdAt?: string;
}

export type ReportFilterScope = typeof ReportFilterScope[keyof typeof ReportFilterScope];


export const ReportFilterScope = {
  Any: 'Any',
  Specific: 'Specific',
  Unspecified: 'Unspecified',
} as const;

export interface RequestPasswordResetRequest {
  /** @nullable */
  email?: string | null;
}

export interface ResendEmailVerificationRequest {
  /** @nullable */
  email?: string | null;
}

export interface ResetPasswordRequest {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  newPassword?: string | null;
}

export interface ReviewCredentialRequest {
  status?: VerificationStatus;
  /** @nullable */
  notes?: string | null;
}

export interface ReviewReportRequest {
  status?: ReportStatus;
  /** @nullable */
  resolutionNote?: string | null;
}

export interface SendMessageRequest {
  /** @nullable */
  body?: string | null;
}

export interface SubmitCredentialRequest {
  /** @nullable */
  mppsNumber?: string | null;
  /** @nullable */
  colfarNumber?: string | null;
  /** @nullable */
  imprefarNumber?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  universityId?: string | null;
  /** @nullable */
  universityOther?: string | null;
  graduationYear?: number;
}

export interface ToggleReactionRequest {
  reactionType?: ReactionType;
}

export interface UniversityDto {
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  shortName?: string | null;
  /** @nullable */
  state?: string | null;
}

export interface UnreadCountResponse {
  count?: number;
}

export interface UnregisterTokenRequest {
  /** @minLength 1 */
  token: string;
}

export interface UpdateCommentRequest {
  /** @nullable */
  content?: string | null;
}

export interface UpdatePostRequest {
  /** @nullable */
  title?: string | null;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  stateCode?: string | null;
}

export interface UpdatePreferencesRequest {
  credentialNotifications?: boolean;
  communityNotifications?: boolean;
  /** @nullable */
  quietHoursStart?: string | null;
  /** @nullable */
  quietHoursEnd?: string | null;
}

export interface UpdateProfileRequest {
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  bio?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
}

export interface UpdateWorkplaceRequest {
  /** @nullable */
  placeId?: string | null;
  /** @nullable */
  name?: string | null;
  type?: WorkplaceType;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  address?: string | null;
  /** @nullable */
  source?: string | null;
}

export interface UploadDocumentRequest {
  /** @nullable */
  documentType?: string | null;
  /** @nullable */
  base64Image?: string | null;
  /** @nullable */
  fileName?: string | null;
}

export interface UserBlockDto {
  id?: string;
  blockedUserId?: string;
  /** @nullable */
  blockedFullName?: string | null;
  reason?: BlockReason;
  createdAt?: string;
}

export interface UserBlockListResponse {
  /** @nullable */
  blocks?: UserBlockDto[] | null;
}

export interface UserSearchResult {
  id?: string;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  verificationStatus?: string | null;
  /** @nullable */
  university?: string | null;
  /** @nullable */
  badge?: string | null;
}

export interface VerifyEmailRequest {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  code?: string | null;
}

export interface WorkplaceDto {
  id?: string;
  /** @nullable */
  placeId?: string | null;
  /** @nullable */
  name?: string | null;
  type?: WorkplaceType;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  address?: string | null;
  /** @nullable */
  source?: string | null;
  createdAt?: string;
  /** @nullable */
  stateCode?: string | null;
  /** @nullable */
  stateName?: string | null;
}

export type GetApiAdminCredentialsParams = {
status?: VerificationStatus;
};

export type GetApiAdminUsersParams = {
page?: number;
pageSize?: number;
search?: string;
isAdmin?: boolean;
};

export type PostApiAdminSeedParams = {
reset?: boolean;
};

export type GetApiAdminReportsParams = {
status?: ReportStatus;
};

export type GetApiAvailabilityRequestsParams = {
StateCode?: string;
DrugConceptId?: string;
IncludeClosed?: boolean;
RequesterUserId?: string;
Cursor?: string;
Limit?: number;
};

export type GetApiConversationsParams = {
cursor?: string;
limit?: number;
};

export type GetApiConversationsIdMessagesParams = {
cursor?: string;
limit?: number;
};

export type PostApiConversationsIdMessagesWithAttachmentBody = {
  Body?: string;
  Image?: Blob;
  Thumbnail?: Blob;
  Width?: number;
  Height?: number;
};

export type GetApiDrugsSearchParams = {
q?: string;
limit?: number;
atcPrefix?: string;
pharmaceuticalForm?: string;
administrationRoute?: string;
dosageForm?: string;
hasVigenteOnly?: boolean;
};

export type GetApiDrugsDrugConceptIdAvailabilityParams = {
productScope?: ReportFilterScope;
registrationNumber?: string;
strengthScope?: ReportFilterScope;
strength?: string;
};

export type GetApiDrugsDrugConceptIdAvailabilityRequestsParams = {
limit?: number;
};

export type GetApiNotificationsParams = {
page?: number;
pageSize?: number;
};

export type GetApiPharmaciesSearchParams = {
query?: string;
latitude?: number;
longitude?: number;
types?: string[];
};

export type GetApiPostsParams = {
PostType?: PostType;
StateCode?: string;
AuthorId?: string;
Q?: string;
Cursor?: string;
Limit?: number;
};

export type PostApiProfileAvatarBody = {
  file?: Blob;
};

export type GetApiUsersSearchParams = {
q?: string;
limit?: number;
};

